/**
 * Tramits actions.
 * @module actions/tramits
 */

import { GET_TRAMITS } from '../../constants/ActionTypes';

/**
 * Get tramits.
 * @function getTramits
 * @param {string} category Optional category to filter by.
 * @returns {Object} Get tramits action.
 */
export function getTramits(category = null) {
  return {
    type: GET_TRAMITS,
    request: {
      op: 'get',
      path: category 
        ? `/@tramits?category=${encodeURIComponent(category)}` 
        : '/@tramits',
    },
  };
}